const selectors = {
  bannerCarousel: "banner-carousel",
};
export default selectors;
